import SafeLocalStorage from 'safe-localstorage';
import { useTripStore } from './../store/trip';
import { boot } from 'quasar/wrappers';

export default boot(() => {
  const tripStore = useTripStore();
  tripStore.$subscribe((mutation, state) => {
    if ((<{ key: string }>mutation.events)?.key === 'tripViewMode') {
      // Save trip view mode after it's changed
      SafeLocalStorage.set('trip/tripViewMode', state.tripViewMode);
    }
  });
});
